<template>
  <div class="paginator-list">
    <slot/>
  </div>
</template>

<script>

export default {
  name: 'PaginatorList'
}
</script>
